module.exports = __webpack_public_path__ + "img/rauhorn.1686fa99.jpg";